module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/~/core-js/library/modules/_iterators.js
// module id = 85
// module chunks = 0